













import { Component, Prop, Vue } from 'vue-property-decorator';
import { MentoringCardWrapper } from '../components';
import MentoringTeamCard from '../teamcard';
import { IMentoringTeamsList, Child, Teams } from './types';

@Component({
  components: {
    MentoringCardWrapper,
    MentoringTeamCard,
  },
})
export default class MentoringTeamsList extends Vue
  implements IMentoringTeamsList {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Teams;

  @Prop({ type: Number, default: 2 })
  readonly step!: number;

  @Prop({ type: Object, default: () => ({}) })
  readonly child!: Child;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/teamslist/MentoringTeamsList.vue